<template>
  <md-card :md-with-hover="!isProdPage">
    <md-card-media-actions style="padding: 10px; cursor: default;">
      <md-card-media
        v-if="info.img"
        md-elevation-2
        style="flex: 1;"
      >
        <md-content class="md-elevation-1">
          <img 
            :src="bookImg"
            @click="moveToPreview(info.preview)"
            :style="'' + (info.preview === 'yes' ? 'cursor:pointer;' : '')" 
          >
          <div
            v-if="info.video_url"
            class="btn-video-play md-raised"
            @click="playYoutube(info.video_url)"
          />
        </md-content>
      </md-card-media>
      <md-card-media 
        class="part-book-text" 
        style="flex: 2;"
      >
        <div 
          class="md-body-2 book-title"
          :style="'font-size: 15px; font-weight: bold;' + (curLang == 'en' ? 'line-height: 1.2em;': '') + (info.preview === 'yes' ? 'cursor:pointer;color:blue;' : '')"
          @click="moveToPreview(info.preview)"
        >
          {{ info.title }}
        </div>
        <div 
          class="md-caption" 
          :style="'margin-bottom: 2px;' + (curLang == 'en' ? 'line-height: 1.2em;' : '')"
        >
          {{ info.publisher }} / {{ info.age }}
        </div>
        <div 
          class="md-caption" 
        >
          {{ info.total_page }}
        </div>
        <div class="md-body-2 price">
          {{ info.price }}
        </div>
        <div class="down-btn-wrapper">
          <DownButton 
            :down-info="info"
            :down-lang="curLang"
          />
        </div>
      </md-card-media>
    </md-card-media-actions>
    <div 
      v-if="info.ios || info.android"
      class="social-share"
    >
      <SocialShare :share-data="shareData" />
    </div>
    <div
      v-if="bookInfo.langs && bookInfo.langs.length > 1"
      :class="'lang-wrap ' + langWrapper "
    >
      <div
        :class="'lang-icon selected ' + curLang" 
        @click="clickLang"
      />
      <div
        v-if="langSel1"
        :class="'lang-icon sel1 ' + langWrapper + ' ' + langSel1"
        @click="clickSel1"
      />
      <div
        v-if="langSel2"
        :class="'lang-icon sel2 ' + langWrapper + ' ' + langSel2"
        @click="clickSel2"
      />
    </div>
  </md-card>
</template>

<script>
import globals from '../globals'

export default {
  name: 'BookCard',
  props: {
    bookInfo: {
      type: Object,
      required: true
    },
    isProdPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    curLang: 'ko',
    info: {},
    bookId: '',
    langWrapper: 'hide',
    langSel1: '',
    langSel2: ''
  }),
  computed: {
    shareData () {
      return {
        url: globals.get('cliSvrUrl') + "?b=" + this.bookId,
        title: this.info.title,
        desc: "기탄 책 설명",
        quote: this.info.title,
        hashtags: this.info.title,
        twitterUser: "vuejs"
      }
    },
    bookImg () {
      if (this.isProdPage) {
        return this.info.img
      }
      else {
        let paths = this.info.img.split('/')
        return this.info.img.replace('/' + paths[paths.length - 2] + '/', '/' + paths[paths.length - 2] + '/thumb/')
      }
    }
  },
  mounted () {
    let lang = this.bookInfo.curLang || 'ko'
    this.curLang = lang
    this.info = this.bookInfo.data[lang]
    this.bookId = this.bookInfo.id
    let addedIdx = 0
    this.bookInfo.langs.forEach(item => {
      if (this.curLang != item) {
        addedIdx += 1
        this['langSel' + addedIdx] = item
      }
    })
  },
  methods: {
    getLangTitle (lang) {
      if (lang == 'ko') return '한국어'
      else if (lang == 'en') return 'English'
      else if (lang == 'jp') return '日本'
    },
    clickLang () {
      this.langWrapper = this.langWrapper == 'show' ? 'hide' : 'show'
    },
    clickSel (lang) {
      if (lang === 'ko') {
        this.curLang = 'ko'
        this.langSel1 = 'en'
        this.langSel2 = 'jp'
      } else if (lang === 'en') {
        this.curLang = 'en'
        this.langSel1 = 'ko'
        this.langSel2 = 'jp'
      } else if (lang === 'jp') {
        this.curLang = 'jp'
        this.langSel1 = 'ko'
        this.langSel2 = 'en'
      }

      if (this.bookInfo.langs.length !== 3) {
        this.langSel2 = ''
      }

      this.info = this.bookInfo.data[this.curLang]
      this.langWrapper = 'lang-wrapper hide'
    },
    clickSel1 () {
      this.clickSel(this.langSel1)
    },
    clickSel2 () {
      this.clickSel(this.langSel2)
    },
    playYoutube (url) {
      this.$emit('update:videoPlay', url)
    },
    moveToPreview (prv) {
      if (prv && prv === 'yes') {
        var userId = this.bookInfo.userId
        this.$http.get('category/' + JSON.stringify({id: this.bookInfo.catgId}))
          .then(res => {
            res.data.forEach((element, idx) => {
              let keyStr = ''
              keyStr += element.c1 && element.c1 !== 'null' ? element.c1 : ''
              keyStr += element.c2 && element.c2 !== 'null' ? '_' + element.c2 : ''
              keyStr += element.c3 && element.c3 !== 'null' ? '_' + element.c3 : ''
              keyStr += element.c4 && element.c4 !== 'null' ? '_' + element.c4 : ''
              keyStr += element.c5 && element.c5 !== 'null' ? '_' + element.c5 : ''
              keyStr += userId ? '_' + userId : ''
              if (keyStr && userId) {
                window.open(globals.prvUrl(keyStr), keyStr)
              }
            })
          })
          .catch(error => {
            console.log('get category error for preview move!!', error);
          })
      }
    }
  }
}
</script>
<style>
  .md-card {
    width: 320px;
    margin: 4px;
    display: inline-block;
    vertical-align: top;
  }
  .book-title {
    margin-bottom: 5px;
    padding-right: 30px;
    word-break: keep-all;
  }
  .part-book-text {
    min-height: 110px;
    text-align: left;
    margin-left: auto;
    margin-right: auto;
  }
  .part-book-text > div {
    margin-left: 20px;
  }
  .price {
    color: red;
    font-weight: bold;
  }
  .social-share {
    position: absolute;
    margin-left: 0px;
    top: 5px;
    right: 5px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  .btn-video-play {
    position: absolute;
    bottom: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-image: url("../assets/imgs/videoPlay.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .lang-wrap {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    overflow: hidden;
    transition: height 0.3s;

  }
  .lang-wrap.show {
    height: 90px;
  }
  .lang-wrap.hide {
    height: 30px;
    transition-delay: 0.3s;
  }
  .lang-icon {
    position: absolute;
    width: 30px; 
    height: 30px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transition: all 0.3s;
    cursor: pointer;
  }
  .sel1.hide {
    top: -0px;
    opacity: 0;
  }
  .sel1.show {
    top: 30px;
    opacity: 1;
  }  
  .sel2.hide {
    top: -0px;
    opacity: 0;
  }
  .sel2.show {
    top: 60px;
    opacity: 1;
  }  
  .lang-icon.ko {
    background-image: url("../assets/imgs/ko.png");
  }
  .lang-icon.en {
    background-image: url("../assets/imgs/en.png");
  }
  .lang-icon.jp {
    background-image: url("../assets/imgs/jp.png");
  }
  .selected {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    z-index: 1;
  }
  .down-btn-wrapper {
    position: absolute;
    bottom: -6px;
  }
</style>